import React from "react";
import { createRoot } from "react-dom/client";
import App from "./pages/App";
import { Provider } from "react-redux";
import store from "./reduxstore/reduxStore";
import "./css";

const container = document.getElementById("container");
const root = createRoot(container!);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
